import { type PropsWithChildren, type JSX } from 'react';

import { cn } from '@videoblocks/design-system';

import { GenerationFlowLayout } from './GenerationFlowLayout';

export interface GenerationFlowSuccessLayoutProps extends PropsWithChildren {
    title?: string;
    subtitle?: string;
    className?: string;
}

export const GenerationFlowSuccessLayout = ({
    title = 'Preview and download your generated video below',
    subtitle = 'A copy has also been sent to your email',
    className,
    children,
}: GenerationFlowSuccessLayoutProps): JSX.Element => {
    return (
        <GenerationFlowLayout className={cn('w-full gap-6 justify-start', className)} title={title} subtitle={subtitle}>
            <div className="w-full flex flex-col gap-3">{children}</div>
        </GenerationFlowLayout>
    );
};
